/* tslint:disable */
/* eslint-disable */
/**
 * Spring API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TaskResponse
 */
export interface TaskResponse {
    /**
     * 
     * @type {number}
     * @memberof TaskResponse
     */
    taskId: number;
    /**
     * 
     * @type {string}
     * @memberof TaskResponse
     */
    taskType: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof TaskResponse
     */
    taskParams: { [key: string]: any; } | null;
    /**
     * 
     * @type {Date}
     * @memberof TaskResponse
     */
    recordCreationTime: Date;
}

/**
 * Check if a given object implements the TaskResponse interface.
 */
export function instanceOfTaskResponse(value: object): value is TaskResponse {
    if (!('taskId' in value) || value['taskId'] === undefined) return false;
    if (!('taskType' in value) || value['taskType'] === undefined) return false;
    if (!('taskParams' in value) || value['taskParams'] === undefined) return false;
    if (!('recordCreationTime' in value) || value['recordCreationTime'] === undefined) return false;
    return true;
}

export function TaskResponseFromJSON(json: any): TaskResponse {
    return TaskResponseFromJSONTyped(json, false);
}

export function TaskResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TaskResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'taskId': json['task_id'],
        'taskType': json['task_type'],
        'taskParams': json['task_params'],
        'recordCreationTime': (new Date(json['record_creation_time'])),
    };
}

export function TaskResponseToJSON(json: any): TaskResponse {
    return TaskResponseToJSONTyped(json, false);
}

export function TaskResponseToJSONTyped(value?: TaskResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'task_id': value['taskId'],
        'task_type': value['taskType'],
        'task_params': value['taskParams'],
        'record_creation_time': value['recordCreationTime'].toISOString(),
    };
}

